export const addLocaleToUrl = (url, locale) => {
  // Create a new URL object
  let urlObj = new URL(url);

  // Get the pathname and split it into parts
  let pathParts = urlObj.pathname.split("/");

  // Insert the locale into the path parts after the domain
  pathParts.splice(1, 0, locale);

  // Reconstruct the pathname with the locale
  urlObj.pathname = pathParts.join("/");

  return urlObj.toString();
};
